var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTrakingAppel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_76_3913)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 8,
    width: 44,
    height: 44,
    rx: 12,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5 21L41 23.5L38.5 26M34 23.5H40.3912",
    stroke: "#5754E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1583 23.7122L28.7556 22.8063C28.4923 22.2139 28.3607 21.9177 28.1638 21.691C27.9171 21.4069 27.5955 21.1979 27.2357 21.0879C26.9486 21 26.6245 21 25.9762 21C25.0279 21 24.5538 21 24.1557 21.1823C23.6869 21.397 23.2634 21.8633 23.0947 22.3506C22.9515 22.7643 22.9925 23.1894 23.0746 24.0397C23.9479 33.0902 28.9098 38.0521 37.9603 38.9254C38.8106 39.0075 39.2357 39.0485 39.6494 38.9053C40.1367 38.7366 40.603 38.3131 40.8177 37.8443C41 37.4462 41 36.9721 41 36.0238C41 35.3755 41 35.0514 40.9122 34.7643C40.8021 34.4045 40.5931 34.0829 40.309 33.8362C40.0823 33.6393 39.7861 33.5077 39.1937 33.2444L38.2878 32.8417C37.6462 32.5566 37.3255 32.4141 36.9995 32.3831C36.6876 32.3534 36.3731 32.3972 36.0811 32.5109C35.776 32.6297 35.5063 32.8544 34.967 33.3038C34.4301 33.7512 34.1617 33.9749 33.8337 34.0947C33.543 34.2009 33.1586 34.2403 32.8523 34.1951C32.5069 34.1442 32.2423 34.0029 31.7133 33.7201C30.0672 32.8405 29.1595 31.9328 28.2799 30.2867C27.9971 29.7577 27.8558 29.4931 27.8049 29.1477C27.7597 28.8414 27.7991 28.457 27.9053 28.1663C28.0251 27.8383 28.2488 27.5699 28.6962 27.033C29.1456 26.4937 29.3703 26.224 29.4892 25.9189C29.6029 25.6269 29.6466 25.3124 29.6169 25.0005C29.5859 24.6745 29.4434 24.3538 29.1583 23.7122Z",
    stroke: "#5754E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_76_3913",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.228553 0 0 0 0 0.216115 0 0 0 0 0.817308 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_76_3913"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_76_3913",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrakingAppel);
export default __webpack_public_path__ + "static/media/iconTrakingAppel.d2994fd5f775c367aafcb29730a6bc0b.svg";
export { ForwardRef as ReactComponent };